import { Route, Routes as ReactRouterRoutes } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { Confirmation, Donation } from './screens';
import { Layout, ScrollToTop } from './components';
import { useConfirmationNavigate } from './hooks';
import { useAnalytics } from './utils';

export const App = () => {
  // This updates the datalayer for analytics
  useAnalytics();
  //
  // paypal success then navigate to confirmation screen
  useConfirmationNavigate();

  const Routes = Sentry.withSentryReactRouterV6Routing(ReactRouterRoutes);

  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route index element={<Donation />} />
        <Route path="/confirmation" element={<Confirmation />} />
        {/* <Route path="*" element={<Donation />} /> */}
      </Routes>
    </Layout>
  );
};
